const TotalPrice=({totalPrice})=>{

    return(
        <div className="totalPrice">Monto total: <span>${totalPrice}</span></div>
    )
}
export default TotalPrice